import * as React from 'react';
import { TextAction } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { Link } from 'react-router-dom';
import { ResponsiveHeaderNav } from '@leagueplatform/solutions-foundation';
import {
  EVENT_NAME,
  PRODUCT_AREA,
  SCREEN_NAMES,
  SUB_PRODUCT_AREA,
  trackAnalyticsEvent,
} from '@leagueplatform/analytics';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { useUserSettingsLinksConfig } from 'components/header-nav/use-user-settings-links-config.hook';
import { usePatientPortalUIConfigOptions } from 'utils/patient-portal-ui-config';
import {
  ANALYTICS_DETAILS,
  ANALYTICS_PRODUCT_AREA_NAMES,
} from 'common/constants';
import { useNavLinksList } from './use-nav-links-list.hook';

const Logo = () => {
  const { formatMessage } = useIntl();

  const { logo } = usePatientPortalUIConfigOptions();
  return (
    <TextAction
      as={Link}
      to={APP_MANAGED_ROUTES.HOME}
      onClick={() =>
        trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA.GET_CARE,
          sub_product_area: SUB_PRODUCT_AREA.HOMESCREEN,
          detail: ANALYTICS_DETAILS.HEADER_NAVIGATE_TO_HOME,
          screen_name: formatMessage({ id: 'STR_HOME' }),
        })
      }
    >
      <img
        src={logo}
        height="32px"
        alt={formatMessage({ id: 'STR_APP_NAME' })}
      />
    </TextAction>
  );
};

export const AppNavBarComponent = React.memo(() => {
  const { navLinks } = useNavLinksList();
  const { userMenu } = useUserSettingsLinksConfig();

  return (
    <ResponsiveHeaderNav
      navLinks={navLinks}
      logo={<Logo />}
      userMenu={userMenu}
      navListStyling={{
        a: {
          color: '$onSurfaceTextPrimary',
        },
      }}
      headerStyling={{
        a: {
          color: '$onSurfaceTextPrimary',
        },
      }}
      dropdownMenuAnalyticsPayload={{
        eventName: EVENT_NAME.SCREEN_LOADED,
        eventProps: {
          product_area: ANALYTICS_PRODUCT_AREA_NAMES.FOUNDATION,
          screen_name: SCREEN_NAMES.SETTINGS,
          sub_product_area: SCREEN_NAMES.SETTINGS,
        },
      }}
    />
  );
});
